import { motion } from "framer-motion";
import { ArrowUpRight, Mail } from "lucide-react";
import { partner, contact } from "../content/site";
import { FadeUp, StaggerGroup, StaggerItem } from "./Reveal";

export default function Partnership() {
  const mailto = `mailto:${contact.email}?subject=${encodeURIComponent(contact.emailSubject)}`;

  return (
    <section id="partner" data-testid="section-partner" className="relative bg-cream py-28 sm:py-40">
      <div className="container-edge">
        <div className="max-w-3xl">
          <FadeUp delay={0.05}>
            <h2 className="font-serif text-4xl leading-[1.05] tracking-tight text-navy sm:text-5xl lg:text-6xl">
              {partner.headline}
            </h2>
          </FadeUp>
          <FadeUp delay={0.1}>
            <p className="mt-8 max-w-xl font-sans text-base font-light leading-relaxed text-navy/70 sm:text-lg">
              {partner.body}
            </p>
          </FadeUp>
        </div>

        <StaggerGroup className="mt-12 flex flex-wrap gap-3">
          {partner.audiences.map((a) => (
            <StaggerItem key={a}>
              <span className="inline-block border border-navy/20 px-5 py-2 font-sans text-sm text-navy/80">
                {a}
              </span>
            </StaggerItem>
          ))}
        </StaggerGroup>

        {/* Contact — info only, giant mailto */}
        <div id="contact" data-testid="section-contact" className="mt-24 border-t border-navy/15 pt-16">
          <div className="grid gap-12 lg:grid-cols-12 lg:items-end">
            <div className="lg:col-span-8">
              <FadeUp>
                <p className="overline mb-6 text-brass">{contact.overline}</p>
              </FadeUp>
              <motion.a
                href={mailto}
                data-testid="contact-email-link"
                className="group block"
                whileHover="hover"
              >
                <h3 className="font-serif text-5xl leading-none tracking-tight text-navy sm:text-7xl lg:text-8xl">
                  {contact.headline}
                </h3>
                <span className="mt-6 inline-flex items-center gap-3 font-sans text-base text-navy/70 sm:text-lg">
                  <Mail size={18} className="text-brass" />
                  <span className="link-underline break-all">{contact.email}</span>
                  <ArrowUpRight
                    size={20}
                    className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                  />
                </span>
              </motion.a>
            </div>

            <div className="lg:col-span-4">
              <FadeUp delay={0.1}>
                <div className="space-y-6 border-l border-navy/15 pl-8">
                  <div>
                    <p className="font-sans text-[10px] uppercase tracking-overline text-navy/40">General</p>
                    <a
                      href={mailto}
                      data-testid="contact-email-secondary"
                      className="mt-2 block font-sans text-sm text-navy/80 link-underline break-all"
                    >
                      {contact.email}
                    </a>
                  </div>
                  <div>
                    <p className="font-sans text-[10px] uppercase tracking-overline text-navy/40">Partnership</p>
                    <p className="mt-2 font-sans text-sm font-light leading-relaxed text-navy/60">
                      Investment, real estate & development inquiries welcome.
                    </p>
                  </div>
                </div>
              </FadeUp>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
